import { useAtom } from "jotai";
import { deletedDays } from "../lib/utils";
import { reactivateUser, userIdentifyAtom } from "../store/user";
import { Button } from "./Button";
import { Sheet, SheetBar, SheetContent, SheetTrigger } from "./Sheet";

export default function DeletedBar() {
  const [userIdentify] = useAtom(userIdentifyAtom);

  const isDeleted =
    userIdentify && userIdentify?.user.pendingDeletionAt !== null;

  const handleReactivate = async () => {
    reactivateUser();
  };

  if (!isDeleted) return null;

  return (
    <Sheet>
      <SheetTrigger className="w-full">
        <div className="-mx-4 px-4 py-2 mt-4 flex items-center gap-2 bg-error text-inverted">
          Your account is in soft-deletion state for{" "}
          {deletedDays(userIdentify?.user.scheduledDeletionAt)}.
          <img src="/img/icon/question.svg" />
        </div>
      </SheetTrigger>
      <SheetContent>
        <div className="flex flex-col items-center">
          <SheetBar />
          <div className="text-size-32 mt-10">Deletion in Progress</div>
          <div className="text-size-16 text-center my-3">
            Your account is in soft-deletion and will be permanently deleted
            after{" "}
            <span className="text-[#62B300]">
              {deletedDays(userIdentify?.user.scheduledDeletionAt)}
            </span>
            . After that, it can't be recovered.
          </div>
          <div className="text-size-16 text-center">
            To keep your account, click "Reactivate My Account".
          </div>
          <Button className="bg-success my-6" onClick={handleReactivate}>
            Reactivate my account
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
